var _ellipse, _path, _path2, _path3, _path4, _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path5, _path6, _path7, _path8, _circle3, _polygon, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse2, _path15, _circle4, _path16, _path17, _path18, _path19, _rect8, _circle5, _circle6, _path20, _rect9, _path21, _rect10, _rect11, _path22, _rect12, _rect13, _path23, _rect14, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _polygon2, _path32, _polygon3, _path33, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 891.012,
    height: 558.80509,
    viewBox: "0 0 891.012 558.80509",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.72647,
    cy: 548.80509,
    rx: 214.72647,
    ry: 10,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M596.30413,170.59745a8.42069,8.42069,0,0,0-8.4117,8.41171V490.8539a8.42156,8.42156,0,0,0,8.4117,8.41273h440.79016a8.42157,8.42157,0,0,0,8.41171-8.41273V179.00916a8.42069,8.42069,0,0,0-8.41171-8.41171Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M597.35534,489.80283h438.68724V180.061H597.35534Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M472.48243,566.99886a11.76187,11.76187,0,0,0-11.5008,9.31023h16.40092v41.161H460.98163A11.75949,11.75949,0,0,0,484.24272,615.02V578.75914A11.76025,11.76025,0,0,0,472.48243,566.99886Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M340.25292,494.96711a21.16831,21.16831,0,0,0-21.14421,21.14421V678.64788a21.16831,21.16831,0,0,0,21.14421,21.1442H443.008a21.1683,21.1683,0,0,0,21.1442-21.1442V516.11132a21.16831,21.16831,0,0,0-21.1442-21.14421Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.90496,
    cy: 537.52483,
    r: 10.78026,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.44788,
    cy: 537.52483,
    r: 10.78026,
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182.74515,
    y: 322.89962,
    width: 5.88014,
    height: 206.78502,
    fill: "#4d4d4d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 199.40555,
    y: 322.89962,
    width: 5.88014,
    height: 206.78502,
    fill: "#4d4d4d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 216.06596,
    y: 322.89962,
    width: 5.88014,
    height: 206.78502,
    fill: "#4d4d4d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 232.72636,
    y: 322.89962,
    width: 5.88014,
    height: 206.78502,
    fill: "#4d4d4d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 249.38677,
    y: 322.89962,
    width: 5.88014,
    height: 206.78502,
    fill: "#4d4d4d"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 266.04717,
    y: 322.89962,
    width: 5.88014,
    height: 206.78502,
    fill: "#4d4d4d"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 282.70758,
    y: 322.89962,
    width: 5.88014,
    height: 206.78502,
    fill: "#4d4d4d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M441.50176,477.8167a42.52878,42.52878,0,0,0,5.86756-21.56053H343.2418a42.52878,42.52878,0,0,0,5.86756,21.56053H327.92893c0,11.36627,9.59814,20.58049,21.438,20.58049h26.23587a47.69093,47.69093,0,0,0,13.57753,1.96h12.25042a47.69093,47.69093,0,0,0,13.57753-1.96h26.23588c11.83987,0,21.438-9.21422,21.438-20.58049Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M364.58559,626.29033a10.38047,10.38047,0,0,1-5.73322,10.2611l-.0527.02912c-9.80126,5.59038-17.82153,9.97922-27.34,9.17073a6.25517,6.25517,0,0,1-5.30962-8.4146l13.53915-25.74674c7.86454-9.16278,13.407-9.17181,23.03056-1.47Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M420.6354,626.29033a10.38047,10.38047,0,0,0,5.73322,10.2611l.0527.02912c9.80125,5.59038,17.82153,9.97922,27.34,9.17073a6.25517,6.25517,0,0,0,5.30962-8.4146l-13.53915-25.74674c-7.86454-9.16278-13.407-9.17181-23.03056-1.47Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M381.28739,322.97294H343.61381a7.94066,7.94066,0,0,1-7.61327-5.64057c-1.16-3.86629-2.65766-7.61751-2.68148-11.01984-.09246-13.20447.56386-21.6092,6.37015-26.95065,19.34632-14.66952,33.36412-11.97114,46.55113,3.43008,4.6293,8.6042,3.441,21.44572.93706,35.24544A5.99319,5.99319,0,0,1,381.28739,322.97294Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.24574,
    cy: 143.55527,
    r: 25.48062,
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "226.846 194.517 191.565 195.497 188.625 157.276 222.926 156.296 226.846 194.517",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M441.12167,456.25617l-24.345,11.26848c-4.079,9.6766-9.70226,9.39816-16.816-.48822-6.79006,11.89087-21.41391,4.76515-28.55856-.42846a32.89394,32.89394,0,0,0-29.75285-.06155L315.67863,351.39363c8.00507-6.88224,18.67219-11.2052,28.9107-14.21035l20.09049,24.99061,13.72033-24.5006c9.53627-7.66726,22.931-7.68131,37.2409-5.88014l8.35539,44.66932C418.48578,411.6991,426.77243,429.37245,441.12167,456.25617Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#c2ccef"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M360.75972,608.15986l-20.5805,1.96005L309.691,475.37274a21.34611,21.34611,0,0,1,20.8378-25.97673h0a21.34611,21.34611,0,0,1,21.16233,24.14113l-3.67172,27.80013Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M422.50122,610.11991l20.5805-.98L473.57,475.37274A21.3461,21.3461,0,0,0,452.7322,449.396h0a21.34611,21.34611,0,0,0-21.16234,24.14113l3.67172,27.80013Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M489.39514,416.74137,471.99242,461.6463c-9.5148-7.27436-17.18607-8.26758-27.74-4.40972-2.91824-.40532-5.09076-6.82053-5.09076-9.7668h0a5.90282,5.90282,0,0,1,5.63479-5.89673l15.92574-.7239a82.91291,82.91291,0,0,0,5.25518-23.79392A45.03054,45.03054,0,0,1,489.39514,416.74137Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M491.10288,418.03524l4.2426-15.83067a26.65531,26.65531,0,0,0-12.02156-31.18612l-67.68287-39.2253-.98,43.121,49.98121,21.56052a88.66843,88.66843,0,0,1,1.33509,22.26719C473.77356,416.42479,483.28734,415.93292,491.10288,418.03524Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#c2ccef"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M386.73035,299.94238l-26.46066,4.90012a18.62043,18.62043,0,0,1-18.62043-18.62044h46.06112Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.72517,
    cy: 134.24504,
    rx: 2.45006,
    ry: 4.90012,
    fill: "#a0616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M419.07114,382.83466h-.2846v-7.79653a4.51242,4.51242,0,0,0-4.51243-4.51242h-16.518a4.51242,4.51242,0,0,0-4.51243,4.51242v42.77234a4.51242,4.51242,0,0,0,4.51243,4.51242h16.518a4.51242,4.51242,0,0,0,4.51243-4.51242V388.38436h.2846Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.8568,
    cy: 212.64695,
    r: 3.9201,
    fill: "#c2ccef"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M401.92072,419.01527c-20.15922,15.825-40.37089,28.99677-55.37134,30.87075l-2.45006-26.95066c14.407-2.07677,33.66941-11.56839,53.90131-22.54054l9.89518-5.1455a10.88036,10.88036,0,0,1,15.868,8.81875v0a10.88035,10.88035,0,0,1-8.10186,11.3625Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M363.69979,450.376l-40.181.98c-13.52025-26.52374-18.42689-54.82723-15.68038-84.71191a19.75446,19.75446,0,0,1,8.51-16.24195l4.23029-2.92866c18.08755,26.85085,29.30662,51.78526,25.48062,72.52176l11.76028-.98C350.20365,429.294,353.72932,439.7762,363.69979,450.376Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#c2ccef"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M189.84135,566.11508s2.076-44.65005,44.63371-39.46009",
    transform: "translate(-154.494 -170.59745)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M189.3416,717.4134c-.05326-.46727-5.07638-46.99385,15.26263-71.61642,7.50633-9.08766,17.5646-14.17692,29.89479-15.1252l.13571,1.754c-11.83457.91049-21.4814,5.785-28.67165,14.48786-19.86315,24.04279-14.92592,69.841-14.87438,70.30051Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33.128,
    y: 349.86528,
    width: 1.77032,
    height: 195.62033,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.26112,
    cy: 337.57123,
    r: 14.53191,
    fill: "#c2ccef"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.07297,
    cy: 460.95102,
    r: 14.44,
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M658.6441,241.79818A24.13386,24.13386,0,1,0,682.778,265.932,24.13386,24.13386,0,0,0,658.6441,241.79818Zm11.11766,26.48616c-.24917,0-1.07724-.00731-1.31907-.022l-4.75593-.12459a.144.144,0,0,0-.12458.06595l-7.13755,10.66971a1.16842,1.16842,0,0,1-.9893.54228h-1.73676c-.41038,0-.54962-.41038-.403-.79143l3.67137-10.47186a.14535.14535,0,0,0-.1319-.19785l-8.9183-.19787a.60018.60018,0,0,0-.48366.22718l-2.76269,3.34893a1.18511,1.18511,0,0,1-.92335.447h-1.22379a.29186.29186,0,0,1-.27847-.38838l1.4583-5.0344a1.19439,1.19439,0,0,0,0-.87205l-1.4583-5.0344a.29186.29186,0,0,1,.27847-.38838h1.23114a1.163,1.163,0,0,1,.92333.447l2.7114,3.29764a.59037.59037,0,0,0,.48364.22715l8.9696-.1319a.14338.14338,0,0,0,.13192-.19785l-3.6714-10.46452c-.14655-.38106-.00731-.79145.40308-.79145h1.73676a1.17769,1.17769,0,0,1,.98927.54228l7.13023,10.67706a.13575.13575,0,0,0,.12458.06595l4.75593-.12459c.23452-.01465,1.0699-.022,1.31907-.022,3.25368,0,5.2982,1.05524,5.2982,2.3523S673.0081,268.28434,669.76176,268.28434Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 559.39419,
    y: 94.20073,
    width: 6,
    height: 2,
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M931.15089,266.79818H919.41358v-2h11.73731Zm-23.47364,0H895.94v-2h11.7373Zm-23.47363,0H872.46631v-2h11.73731Zm-23.47363,0H848.99268v-2H860.73Zm-23.47364,0h-11.7373v-2h11.7373Zm-23.47363,0h-11.7373v-2h11.7373Zm-23.47363,0H778.57178v-2h11.73731Zm-23.47363,0H755.09815v-2h11.73731Zm-23.47364,0h-11.7373v-2h11.7373Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 788.39419,
    y: 94.20073,
    width: 6,
    height: 2,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 559.39419,
    y: 163.20073,
    width: 6,
    height: 2,
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M931.15089,335.79818H919.41358v-2h11.73731Zm-23.47364,0H895.94v-2h11.7373Zm-23.47363,0H872.46631v-2h11.73731Zm-23.47363,0H848.99268v-2H860.73Zm-23.47364,0h-11.7373v-2h11.7373Zm-23.47363,0h-11.7373v-2h11.7373Zm-23.47363,0H778.57178v-2h11.73731Zm-23.47363,0H755.09815v-2h11.73731Zm-23.47364,0h-11.7373v-2h11.7373Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 788.39419,
    y: 163.20073,
    width: 6,
    height: 2,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 559.39419,
    y: 232.20073,
    width: 6,
    height: 2,
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M931.15089,404.79818H919.41358v-2h11.73731Zm-23.47364,0H895.94v-2h11.7373Zm-23.47363,0H872.46631v-2h11.73731Zm-23.47363,0H848.99268v-2H860.73Zm-23.47364,0h-11.7373v-2h11.7373Zm-23.47363,0h-11.7373v-2h11.7373Zm-23.47363,0H778.57178v-2h11.73731Zm-23.47363,0H755.09815v-2h11.73731Zm-23.47364,0h-11.7373v-2h11.7373Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 788.39419,
    y: 232.20073,
    width: 6,
    height: 2,
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M658.21123,311.79818A23.32284,23.32284,0,1,0,681.53407,335.121,23.32284,23.32284,0,0,0,658.21123,311.79818Zm-10.906,22.52967,1.28889-6.85522c.33285-1.86253,1.19683-3.32847,2.81858-3.32847h2.43613l.14165-.55946a2.26477,2.26477,0,0,1,2.19537-1.70672h4.03666a2.26636,2.26636,0,0,1,2.19536,1.69965l.14162.56653h2.45032c1.58634,0,2.42909,1.43762,2.82567,3.32138v.00709l1.296,6.86231a.28253.28253,0,0,1-.39658.3116l-1.7988-.82857a.26959.26959,0,0,1-.16288-.20536l-1.14725-6.06207c-.21245-.779-.50989-1.13309-1.14018-1.13309H651.9438c-.62319,0-.96311.37533-1.14015,1.13309l-1.14728,6.062a.28489.28489,0,0,1-.16288.20539l-1.7917.82149a.2843.2843,0,0,1-.39659-.31161Zm24.97763,4.412-3.87375,9.62419a8.06114,8.06114,0,0,1-4.01541-1.558,16.95979,16.95979,0,0,1-5.61589,1.31722c-.1983.00707-.38953.01416-.56656.01416s-.36825,0-.56656-.01416a17.13708,17.13708,0,0,1-5.61589-1.31722,8.06114,8.06114,0,0,1-4.01541,1.558l-3.87375-9.62419a1.31564,1.31564,0,0,1-.09207-.47451,1.27947,1.27947,0,0,1,.74357-1.16141l13.17931-6.055a.55652.55652,0,0,1,.47448,0l13.18637,6.055a1.27947,1.27947,0,0,1,.74358,1.16141A1.3158,1.3158,0,0,1,672.28283,338.73984Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M666.617,398.19175h-7.01517a.28717.28717,0,0,0-.28632.28634v10.02168a.28716.28716,0,0,0,.28632.28632H666.617a1.14869,1.14869,0,0,0,1.14534-1.14533v-8.30367A1.1487,1.1487,0,0,0,666.617,398.19175Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M665.04223,410.93361a1.72331,1.72331,0,1,0,.27213,0A1.72009,1.72009,0,0,0,665.04223,410.93361Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M651.30538,410.93361a1.72331,1.72331,0,1,0,.27213,0A1.72009,1.72009,0,0,0,651.30538,410.93361Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M657.0249,398.19175H650.024a1.164,1.164,0,0,0-1.15964,1.15965v8.275a1.164,1.164,0,0,0,1.15964,1.15965h7.00087a.28716.28716,0,0,0,.28631-.28632V398.47809A.28716.28716,0,0,0,657.0249,398.19175Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M658.31339,380.91629a23.57481,23.57481,0,1,0,23.5748,23.57481A23.57481,23.57481,0,0,0,658.31339,380.91629Zm11.45335,33.167a2.87176,2.87176,0,0,1-2.86335,2.86331h-17.18a2.87175,2.87175,0,0,1-2.86334-2.86331v-19.757a2.29739,2.29739,0,0,1,2.29066-2.29067h18.32537a2.29741,2.29741,0,0,1,2.29067,2.29067Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M666.68865,394.03992H649.93813a1.00455,1.00455,0,1,0,0,2.00433h16.75052a1.00455,1.00455,0,1,0,0-2.00433Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M983.88819,280.79818a15,15,0,1,1,15-15A15.01672,15.01672,0,0,1,983.88819,280.79818Zm0-28a13,13,0,1,0,13,13A13.01474,13.01474,0,0,0,983.88819,252.79818Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#c2ccef"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "835.101 90.908 833.687 89.494 829.394 93.787 825.101 89.494 823.687 90.908 827.98 95.201 823.687 99.494 825.101 100.908 829.394 96.615 833.687 100.908 835.101 99.494 830.808 95.201 835.101 90.908",
    fill: "#c2ccef"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M983.88819,349.79818a15,15,0,1,1,15-15A15.01672,15.01672,0,0,1,983.88819,349.79818Zm0-28a13,13,0,1,0,13,13A13.01474,13.01474,0,0,0,983.88819,321.79818Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#c2ccef"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "835.101 159.908 833.687 158.494 829.394 162.787 825.101 158.494 823.687 159.908 827.98 164.201 823.687 168.494 825.101 169.908 829.394 165.615 833.687 169.908 835.101 168.494 830.808 164.201 835.101 159.908",
    fill: "#c2ccef"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M983.88819,418.79818a15,15,0,1,1,15-15A15.0164,15.0164,0,0,1,983.88819,418.79818Zm0-28a13,13,0,1,0,13,13A13.01474,13.01474,0,0,0,983.88819,390.79818Z",
    transform: "translate(-154.494 -170.59745)",
    fill: "#c2ccef"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "835.101 228.908 833.687 227.494 829.394 231.787 825.101 227.494 823.687 228.908 827.98 233.201 823.687 237.494 825.101 238.908 829.394 234.615 833.687 238.908 835.101 237.494 830.808 233.201 835.101 228.908",
    fill: "#c2ccef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.875b199f4977db62447c1f2679152f86.svg";
export { ForwardRef as ReactComponent };